import { TurnToFlow } from './email-flows-common'

export function checkTurntoflow(): void {
  const params = new URLSearchParams(document.location.search)
  const turntoflow = params.get('turntoflow') as TurnToFlow
  if (turntoflow) {
    import(/* webpackChunkName: 'email-flow-entry' */ './email-flow-entry').then((emailFlowEntry) => {
      emailFlowEntry.processTurntoflow(turntoflow, params)
    })
  }
}
